// extracted by mini-css-extract-plugin
export default {"remove-btn-wrapper":"locale_remove-btn-wrapper__-EyEf"};